import { InfoOutlined } from '@mui/icons-material'
import { Theme, Tooltip, TooltipProps } from '@mui/material'
import { ReactNode } from 'react'
import type { SvgIconComponent } from '@mui/icons-material'

export type InformationTooltipProps = {
  text: ReactNode
  position?: 'start' | 'end'
  size?: number
  color?: string | ((theme: Theme) => string)
  ariaLabel?: string
  onOpen?: () => void
  stopClickPropagation?: boolean
  placement?: TooltipProps['placement']
  align?: 'text' | 'center'
  icon?: SvgIconComponent
}

export const InformationTooltip = ({
  text,
  position = 'end',
  size = 14,
  color = 'fg.muted',
  ariaLabel,
  onOpen,
  stopClickPropagation = false,
  placement,
  align = 'text',
  icon: Icon = InfoOutlined,
}: InformationTooltipProps) => (
  <Tooltip title={text} arrow onOpen={onOpen} placement={placement}>
    <Icon
      role="img"
      aria-hidden={false}
      tabIndex={0}
      aria-label={ariaLabel ?? (typeof text === 'string' ? text : undefined)}
      onClick={
        stopClickPropagation
          ? (event) => {
              event.preventDefault()
              event.stopPropagation()
            }
          : undefined
      }
      onKeyDown={
        stopClickPropagation
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                event.stopPropagation()
              }
            }
          : undefined
      }
      sx={{
        color,
        display: 'inline-block',
        width: size,
        height: size,
        marginInlineStart: position === 'end' ? 0.5 : 0,
        marginInlineEnd: position === 'start' ? 0.5 : 0,
        cursor: 'pointer',
        // Nudges the icon to optically centre beside inline text; a flex parent centres it without this.
        ...(align === 'text' ? { verticalAlign: 'middle', transform: `translateY(${size > 14 ? -2 : -1}px)` } : {}),
      }}
      // Allows reordering in MuiInputLabel in Omui theme 2
      className="information-tooltip"
    />
  </Tooltip>
)
